// レジ 注文画面

import { useState } from "react";
import Header from "components/Frame/Header";

/* eslint-disable no-magic-numbers */
const data = {
  location: "テーブル",
  customer: {
    code:      "0002",
    location:  "01", // テーブル
    number:    2, // 人数
    visitTime: "2022/11/21 11:00",
    items:     [
      { name: "生ビール（中）", amount: 960, number: 2 },
      { name: "特製つくね", amount: 280, number: 1 }
    ]
  },
  list: [
    {
      location:  "01",
      number:    2,
      visitTime: "11:00",
      status:    "会計前",
      amount:    "2,000",
      items:     [
        { name: "生ビール（中）", amount: 960, number: 2 },
        { name: "特製つくね", amount: 280, number: 1 }
      ]
    }
  ]
};
/* eslint-enable no-magic-numbers */

const Page = function () {
  const [currentMode, setMode] = useState("sheet");
  const modeList = [
    { name: "オーダーシート", mode: "sheet" },
    { name: "商品検索", mode: "search" },
    { name: "フリー商品", mode: "free" }
  ];
  return (
    <div className="page">
      <Header>新規来店</Header>
      <div className="container-fluid">
        <div className="row color-bg-primary color-text-clear text-nowrap clearfix mt-3 px-2 py-2">
          <div className="col-2" style={{ fontWeight: "bold", lineHeight: 2 }}>
            <span>S:</span>
            <span>{data.customer.code}</span>
          </div>
          <div className="col-3" style={{ fontWeight: "bold", lineHeight: 2 }}>
            <span>{data.location}:</span>
            <span>{data.customer.code}</span>
          </div>
          <div className="col-2" style={{ fontWeight: "bold", lineHeight: 2 }}>
            <span>人数:</span>
            <span>{data.customer.number}名</span>
          </div>
          <div className="col-3" style={{ fontWeight: "bold", lineHeight: 2 }}>
            <span>来店:</span>
            <span>{data.customer.visitTime}</span>
          </div>
          <div className="col-2 text-end">
            <button
              className="btn btn-sm color-bg-primary color-text-clear color-border-clear"
              style={{ borderRadius: "2em" }}
            >
              詳細
            </button>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div
            className="col-md-8 border-end color-border-primary color-bg-secondary-light"
            style={{ minHeight: "100px" }}
          >
            {/* モード選択 */}
            <div
              className="color-bg-primary-light clearfix my-2"
              style={{
                borderRadius: "1.2em",
                height:       "2.4em",
                lineHeight:   2.4 // eslint-disable-line no-magic-numbers
              }}
            >
              {modeList.map((mode, i) => {
                let width = Math.floor(100 / modeList.length);
                if (i === 0) {
                  width += 100 % modeList.length;
                }
                const classNames = ["float-start text-center cursor-pointer"];
                if (mode.mode === currentMode) {
                  classNames.push("color-bg-primary color-text-clear");
                }
                return (
                  <div
                    key={`mode-${i}`}
                    className={classNames.join(" ")}
                    style={{
                      width:        `${width}%`,
                      borderRadius: "1.2em",
                      cursor:       "pointer"
                    }}
                    onClick={() => setMode(mode.mode)}
                  >
                    {mode.name}
                  </div>
                );
              })}
            </div>
            {/* モードごとの商品選択画面 */}
            <div></div>
          </div>
          {/* 選択済み商品リスト */}
          <div className="col-md-4">
            <div className="row">
              <div className="col-12 col-md-6"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page;
